import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import './App.css';

import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Error from "./components/Error/Error";

import ListNews from "./components/News/List";
import ListSessions from "./components/Sessions/List";
import ListPublications from "./components/Publications/List";
import ListSounds from "./components/Sounds/List";
import About from "./components/About/About";

function App() {
  return (
    <Router>
      <div className="container-fluid p-5">

        <Navbar />

        <Routes>
          <Route exact path="/" element={ <ListNews /> } />
          <Route exact path="/news" element={ <ListNews /> } />
          <Route exact path="/sessions" element={ <ListSessions /> } />
          <Route exact path="/publications" element={ <ListPublications /> } />
          <Route exact path="/sounds" element={ <ListSounds /> } />
          <Route exact path="/about" element={ <About /> } />
          <Route path="*" element={ <Error /> } />
        </Routes>

        <Footer />

      </div>
    </Router>
  );
}

export default App;
